// extracted by mini-css-extract-plugin
export default {"draw-table-row":"CompletedDrawsTable_draw-table-row__J9e4l","row-item-name":"CompletedDrawsTable_row-item-name__gxqGf"};